module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Chuck-Taylors-Web-1280.128f904d.jpg";